import type { DocPageContent } from '../docs-content'

const page = {
  order: 4,
  slug: 'editor',
  title: '编辑器布局与导航',
  description: '工具栏、面板、预览、时间线和工作区布局。',
  category: '开始',
  sections: [
    {
      title: '主要界面',
      items: [
        '使用编辑器工具栏进行"返回项目"、工作区标签、项目规格、设置、快捷键、保存和导出。',
        '使用媒体侧边栏进行媒体、文本、形状、特效、转场和 AI 操作。',
        '使用预览监视器查看当前帧、叠加层、蒙版、示波器和播放状态。',
        '使用时间线管理轨道、片段、标记、入/出点、吸附、修剪工具和缩放。',
      ],
    },
    {
      title: '工作区',
      items: [
        '使用"编辑"工作区进行剪辑、排列、文本、形状、特效、转场、预览和片段属性操作。',
        '使用"颜色"工作区进行调色工作、色彩工具和示波器。',
        '从中央工具栏标签切换工作区。',
      ],
    },
    {
      title: '辅助面板',
      items: [
        '使用"属性"面板编辑选中的片段。',
        '使用"关键帧"编辑器调整动画时间和曲线。',
        '使用"设置"调整通用、时间线、AI、存储和语言偏好。',
      ],
    },
  ],
} satisfies DocPageContent

export default page